const Graph = require('./BaseGraph')

module.exports = class ContactGraph extends Graph 
{
    constructor(apiDomain, path="contacts")
    {
        super(apiDomain, path)
    }

    accountQuery(fields, params=null)
    {
        if (params)
            return { type: 'account', query: this.queryString('account', fields, params) }

        return { type: 'account', query: `query getAccount ($contactId: String!) {
            account(contactId: $contactId)
            ${this.queryFields(fields)}
        }` }
    }

    contactQuery(fields, params=null)
    {
        if (params)
            return { type: 'contact', query: this.queryString('contact', fields, params) }

        return { type: 'contact', query: `query getContact ($email: String!) {
            contact(email: $email)
            ${this.queryFields(fields)}
        }` }
    }

    updateAdressProfile(fields, params=null)
    {
        if (params)
            return { type: 'addressProfile', query: `mutation {
                addressProfile(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'addressProfile', query: `mutation addressProfile ($contact_id: String!, $street: String!, $city: String!, $zip_code: String!, $province_id: String!, $country_id: String!) {
            addressProfile(contact_id: $contact_id, street: $street, city: $city, zip_code: $zip_code, province_id: $province_id, country_id: $country_id)
            ${this.queryFields(fields)}
        }` }
    }

    updateContactProfile(fields, params=null)
    {
        if (params)
            return { type: 'contactProfile', query: `mutation {
                contactProfile(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'contactProfile', query: `mutation contactProfile ($contact_id: String!, $firstname: String!, $lastname: String!, $mobile: String!, $phone_number: String!, $mobileCountryCode: String!, $phoneNumberCountryCode: String!) {
            contactProfile(contact_id: $contact_id, firstname: $firstname, lastname: $lastname, mobile: $mobile, phone_number: $phone_number, mobileCountryCode: $mobileCountryCode, phoneNumberCountryCode: $phoneNumberCountryCode)
            ${this.queryFields(fields)}
        }` }
    }

    updateSocialSpaces(fields, params=null)
    {
        if (params)
            return { type: 'socialSpace', query: `mutation {
                socialSpace(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'socialSpace', query: `mutation socialSpace ($contact_id: String!, $facebook: String!, $twitter: String!, $linkedin: String!, $pinterest: String!) {
            socialSpace(contact_id: $contact_id, facebook: $facebook, twitter: $twitter, linkedin: $linkedin, pinterest: $pinterest)
            ${this.queryFields(fields)}
        }` }
    }

    updateLoginDetails(fields, params=null)
    {
        if (params)
            return { type: 'loginDetails', query: `mutation {
                loginDetails(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'loginDetails', query: `mutation loginDetails ($contact_id: String!, $email: String!, $password: String!) {
            loginDetails(contact_id: $contact_id, email: $email, password: $password)
            ${this.queryFields(fields)}
        }` }
    }

    updateMisc(fields, params=null)
    {
        if (params)
            return { type: 'updateMisc', query: `mutation {
                updateMisc(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'updateMisc', query: `mutation updateMisc ($contact_id: String!, $family: String!, $occupation: String!, $hobbies_n_interest: String!, $data: [String]) {
            updateMisc(contact_id: $contact_id, family: $family, occupation: $occupation, hobbies_n_interest: $hobbies_n_interest, data: $data)
            ${this.queryFields(fields)}
        }` }
    }

    unsubscribeContact(fields, params=null)
    {
        if (params)
            return { type: 'unsubscribeContact', query: `mutation {
                unsubscribeContact(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'unsubscribeContact', query: `mutation unsubscribeContact ($account_id: String!, $list_id: String!, $email: String!) {
            unsubscribeContact(account_id: $account_id, list_id: $list_id, email: $email)
            ${this.queryFields(fields)}
        }` }
    }


    addExploreModule(fields, params=null)
    {
        if (params)
            return { type: 'addExploreModule', query: `mutation {
                addExploreModule(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'addExploreModule', query: `mutation addExploreModule ($contact_id: String, $module: String!, $key: String!, $content_id: Int!, $value: String!, $user_id: String) {
            addExploreModule(contact_id: $contact_id, module: $module, key: $key, content_id: $content_id, value: $value, user_id: $user_id)
            ${this.queryFields(fields)}
        }` }
    }

    exploreModuleQuery(fields, params=null)
    {
        if (params)
            return { type: 'explore', query: this.queryString('explore', fields, params) }

        return { type: 'account', query: `query getExploreModule ($contact_id: String, $user_id: String) {
            explore(contact_id: $contact_id, user_id: $user_id)
            ${this.queryFields(fields)}
        }` }
    }

    uploadAvatar(fields, params=null)
    {
        if (params)
            return { type: 'uploadAvatar', query: `mutation {
                uploadAvatar(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'uploadAvatar', query: `mutation uploadAvatar ($contact_id: String!, $image: String) {
            uploadAvatar(contact_id: $contact_id, image: $image)
            ${this.queryFields(fields)}
        }` }
    }

    registerMutation(fields, params = null) {
        if (params)
            return {
                type: 'register', query: `mutation {
                register(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return {
            type: 'register', query: `mutation register($first_name: String!, $last_name: String!, $email: String!, $phone: String!, $street:String!, $cityTown: String!, $stateProvince: String!, $zipPostal:String!, $tag:String!, $list_id:String!) {
            register(first_name: $first_name, last_name: $last_name, email: $email, phone: $phone, street: $street, cityTown:$cityTown,stateProvince:$stateProvince,zipPostal:$zipPostal,tag:$tag,list_id:$list_id)
            ${this.queryFields(fields)}
        }` }
    }


    smartStartMutation(fields, params = null) {
        if (params)
            return {
                type: 'smartStart', query: `mutation {
                smartStart(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return {
            type: 'smartStart', query: `mutation smartStart($contact_id: String!, $value: String, $date_completed: String, $other_data: String) {
            smartStart(contact_id: $contact_id, value: $value, date_completed: $date_completed, other_data: $other_data)
            ${this.queryFields(fields)}
        }` }
    }

    smartStartQuery(fields, params = null) {
        if (params)
            return { type: 'smartStart', query: this.queryString('smartStart', fields, params) }

        return {
            type: 'smartStart', query: `query smartStart($contact_id: String!, $name: String!) {
            activity(contact_id: $contact_id, name: $name)
            ${this.queryFields(fields)}
        }` }
    }

    //  Smart Start All Query
    smartStartAllQuery(fields, params = null) {
        if (params)
            return { type: 'smartStartAll', query: this.queryString('smartStartAll', fields, params) }

        return {
            type: 'smartStartAll', query: `query smartStartAll($contact_id: String!) {
            allActivity(contact_id: $contact_id)
            ${this.queryFields(fields)}
        }` }
    }
}